import { useMutation } from 'react-query';

import { berryApiService } from 'src/services/berry.service';
import { IBerrySession } from 'src/models/berry.model';

export default function useBerrySession() {
  return useMutation<IBerrySession, Error, void>(() =>
    berryApiService.startSession(),
  );
}
